import SvgIcon from '@material-ui/core/SvgIcon';

export default function Undo(props:any) {
  return (
    <SvgIcon viewBox="0 0 16 18" {...props}>
     <path d="M16 11.3143C16 15.0069 13.09 18 9.5 18H2V15.9429H9.5C12 15.9429 14 13.8857 14 11.3143C14 8.74286 12 6.68571 9.5 6.68571H3.83L6.91 9.864L5.5 11.3143L0 5.65714L5.5 0L6.92 1.45029L3.83 4.62857H9.5C13.09 4.62857 16 7.62171 16 11.3143Z" fill="currentColor"/>
    </SvgIcon>
  );
}

 
